import { useSearchParams } from 'react-router-dom';
import getCookieValue from 'helpers/get_cookie';

const useLeadSource = () => {
  const [searchParams] = useSearchParams();
  const utmSource = searchParams.get('utm_source');
  const tierSource = searchParams.get('tier_source') || '';
  const fromBd = !!searchParams.get('from_bd') || false;
  const tier = searchParams.get('tier') || '';
  const soCookie = getCookieValue('so');
  let leadSource = 'Direct';

  if (utmSource) {
    leadSource = utmSource;
  } else if (soCookie && soCookie !== 'Direct') {
    leadSource = getCookieValue('so') as string;
  }

  return { leadSource, tierSource, tier, fromBd };
};

export default useLeadSource;
